<template>
  <custom-callout border-color="orange" :has-toggle="false">
    <div class="py-2">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-3 mt-md-0 mt-sm-5"
          :gradient="false"
          icon="fas fa-sync-alt p-2"
          icon-background="#ff7058"
          icon-color="white"
          icon-size="14px"
          title="Generar Catálogo"
        />
      </div>
      <validation-observer ref="formObserver">
        <div class="row p-2">
          <div class="col-md-4">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.academicYear"
                class="w-100"
                :custom-error-msg="'El año académico es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Año Académico:"
                :options="collections.academicYears"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>

          <div class="col-md-4">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.area"
                class="w-100"
                :custom-error-msg="'El área es requerida.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Área:"
                :options="collections.areas"
                placeholder="Seleccione"
                @input="onAreaChange"
              />
            </validation-provider>
          </div>
          <div class="col-md-4">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.recruitmentType"
                class="w-100"
                :custom-error-msg="'El tipo de proveedor es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Proveedor:"
                :options="providerTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <action-button
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-4"
            @click="onCancelHandler"
          />
          <action-button
            i="fas fa-sync-alt"
            text="Generar"
            variant="success pl-3 pr-3"
            @click="onGenerateHandler"
          />
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';

import proposalRecruitmentTypes from '@/utils/constants/proposalRecruitmentTypes.js';
import proposalAreas from '@/utils/constants/proposalAreas.js';

export default {
  name: 'DocumentConfigurationGeneration',
  components: {
    CustomCallout,
    ActionButton,
    CustomDropDown,
    IconView,
  },
  props: {
    collections: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      providerTypes: [],
      model: {
        academicYear: null,
        area: null,
        recruitmentType: null,
      },
    };
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    onAreaChange() {
      this.recruitmentTypes = [];
      this.model.recruitmentType = null;
      if (this.model.area) {
        let providerTypesIds = [
          proposalRecruitmentTypes.Compania,
          proposalRecruitmentTypes.EntidadEducativa,
          proposalRecruitmentTypes.Individuo,
        ];
        if (this.model.area.id == proposalAreas.RemedioProvisional) {
          providerTypesIds = [
            proposalRecruitmentTypes.Compania,
            proposalRecruitmentTypes.DBA,
            proposalRecruitmentTypes.Individuo,
          ];
        }

        this.providerTypes = this.collections.providerTypes.filter((c) =>
          providerTypesIds.includes(c.id)
        );
      }
    },
    async onGenerateHandler() {
      const isValid = await this.$refs.formObserver.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Favor, debe completar los campos para continuar.',
          'error'
        );
        return;
      }

      this.$emit('on-create', {
        academicYearId: this.model.academicYear.id,
        areaId: this.model.area.id,
        recruitmentTypeId: this.model.recruitmentType.id,
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .dot {
    width: 30px !important;
    height: 30px !important;
  }
}
</style>
